// @flow
import type { DataLoaderParams } from '../../../types/DataLoaderParams';
import { fetchAllSellersIfNeeded } from '../../../redux/modules/seller';
import { recordAnalyticsForSellerDirectoryPageView } from '../../../redux/modules/analytics';

export default ({ store }: DataLoaderParams) => {
    const { dispatch } = store;
    return Promise.all([dispatch(fetchAllSellersIfNeeded())]).then(() => {
        return dispatch(recordAnalyticsForSellerDirectoryPageView());
    });
};
